import React, { useMemo } from "react";

import DataGrid, { Column, Editing, Form } from "devextreme-react/data-grid";
import { RequiredRule, SimpleItem } from "devextreme-react/form";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import "devextreme/ui/date_box";
import "devextreme/ui/select_box";
import "devextreme/ui/text_area";

import { useFxDispatch, useFxSelector } from "@app/statefx";
import { schema } from "@app/statefx/schema";
import { sfxInserOrUpdateAccount } from "@app/statefx/xThunks/ds-profile";

import type { TDBAccount } from "@app/types/insider";
/* 

export type TDBAccount = {
  CONTMA_ID: number;
  NR_CONT: string;
  BANCA: string;
  MONEDA: string;
  OBSERVATII: string;
  SOCIETATEA: string;
  NICK: string;
  EID: number;
  ADRESA: string;
  SWIFT: string;
  BANCA_CRSP: string;
  ACTIV: number;
  CONT_IMPLICIT: number;
};
export type TCurrency = 'EUR' | 'USD' | 'GBP' | 'RON' | 'CHF' | 'MDL';
*/
export const AccountsGrid = () => {
  const dispatch = useFxDispatch();
  const data_ = useFxSelector(schema.issuerBankAccounts.selectTableAsList);
  const issuerSelected_ = useFxSelector(schema.uiContractorsEditing.select);
  const issuerSelected = issuerSelected_?.emitentID || -1;
  const monede = useFxSelector(schema.currencies.select);
  const data = useMemo(
    () => data_.filter((item: TDBAccount) => item.EID === issuerSelected),
    [data_, issuerSelected]
  );

  const dataSource = new DataSource({
    store: new CustomStore({
      loadMode: "raw",
      key: "CONTMA_ID",
      load: () => {
        return data;
      },
      insert: async (values) => {
        dispatch(sfxInserOrUpdateAccount(values));
        return Promise.resolve(values);
      },
      update: async (key, values) => {
        const data0 = data.find((p: TDBAccount) => p.CONTMA_ID === key);
        if (data0 === undefined) {
          dispatch(sfxInserOrUpdateAccount(values));
        } else {
          return dispatch(sfxInserOrUpdateAccount({ ...data0, ...values }));
        }
        return Promise.resolve(values);
      },
    }),
  });
  const newRowHandler = (e: any) => {
    e.data = {
      CONTMA_ID: 0,
      NR_CONT: "",
      BANCA: "",
      MONEDA: "RON",
      OBSERVATII: "",
      SOCIETATEA: "",
      NICK: "",
      EID: issuerSelected,
      ADRESA: "",
      SWIFT: "",
      BANCA_CRSP: "",
      ACTIV: 1,
      CONT_IMPLICIT: 0,
    };
  };
  return (
    <DataGrid
      dataSource={dataSource}
      showBorders={true}
      showRowLines={true}
      showColumnLines={true}
      columnAutoWidth={false}
      allowColumnReordering={true}
      allowColumnResizing={true}
      autoNavigateToFocusedRow={true}
      focusedRowEnabled={false}
      filterSyncEnabled={true}
      repaintChangesOnly={true}
      renderAsync={true}
      wordWrapEnabled={true}
      noDataText={""}
      // onEditorPreparing={editorPreparing}
      showColumnHeaders={true}
      onInitNewRow={newRowHandler}
      // onEditingStart={editingStart}
      // onSelectionChanged={selectionChanged}
      // onCellPrepared={cellPrepared}
      // onRowPrepared={onRowPrepared}
      // onRowValidating={onRowValidating}
      //   onSaving={onSaving}
    >
      <Editing
        mode={"form"}
        allowUpdating={true}
        allowDeleting={false}
        allowAdding={true}
        useIcons={true}
      >
        <Form labelMode="floating" labelLocation="top" colCount={2}>
          <SimpleItem
            dataField={"NR_CONT"}
            editorType={"dxTextBox"}
            editorOptions={{ width: "100%" }}
          >
            <RequiredRule />
          </SimpleItem>
          <SimpleItem
            dataField={"BANCA"}
            editorType={"dxTextBox"}
            editorOptions={{ width: "100%" }}
          >
            <RequiredRule />
          </SimpleItem>
          <SimpleItem
            dataField={"ACTIV"}
            editorType={"dxCheckBox"}
            editorOptions={{ width: "100%" }}
          />
          <SimpleItem
            dataField={"MONEDA"}
            editorType={"dxSelectBox"}
            editorOptions={{
              items: monede,
            }}
          >
            <RequiredRule />
          </SimpleItem>
          <SimpleItem
            dataField={"ADRESA"}
            colSpan={2}
            editorType={"dxTextArea"}
            editorOptions={{ width: "100%", height: "60px" }}
          />
          <SimpleItem
            dataField={"OBSERVATII"}
            colSpan={2}
            editorType={"dxTextArea"}
            editorOptions={{ width: "100%", height: "60px" }}
          />
          <SimpleItem
            dataField={"SWIFT"}
            editorType={"dxTextBox"}
            editorOptions={{ width: "100%" }}
          />
          <SimpleItem
            dataField={"BANCA_CRSP"}
            editorType={"dxTextBox"}
            editorOptions={{ width: "100%" }}
            label={{ text: "Banca Corespondenta" }}
          />
        </Form>
      </Editing>
      <Column dataField={"EID"} caption={"Emitent"} visible={false} />
      <Column dataField={"NR_CONT"} caption={"IBAN"} />
      <Column dataField={"BANCA"} caption={"Banca"} />
      <Column dataField={"MONEDA"} caption={"Moneda"} />
      <Column dataField={"OBSERVATII"} caption={"Observatii"} visible={false} />
      <Column dataField={"ADRESA"} caption={"Adresa"} visible={false} />
      <Column dataField={"SWIFT"} caption={"Swift"} visible={false} />
      <Column dataField={"BANCA_CRSP"} caption={"Banca Crsp"} visible={false} />
      <Column dataField={"ACTIV"} caption={"Activ"} visible={false} />
    </DataGrid>
  );
};
